import React from "react" 
import { Plus, Trash2, Copy } from "lucide-react"
import { cn } from "lib/utils"
import { Pagination } from "lib/components"
import { GridTableHeader, GridTableRow } from "."

export default function GridTable({
  title,
  addItemFn,
  isSelectedFn=() => false,
  rowClickFn=()=>{},
  dataset,
  columns=[],
  actions=[],
  pagination,
  className="",
}:{
  title?:string
  addItemFn?:any
  isSelectedFn?:any
  rowClickFn?:any
  dataset:any[]
  columns?:any[]
  actions?:any[]
  pagination?:any 
  className?:string
}){

  return (
    <div className={cn("w-full flex flex-col gap-3", className)}>
      
      { title !== undefined && (
        <div className="w-full flex justify-between items-center bg-slate-700 px-2 py-1">
          <h3 className="text-sm uppercase tracking-wider">{ title }</h3>
          { addItemFn !== undefined && (
            <Plus className="size-5 cursor-pointer stroke-1 stroke-gray-100" onClick={addItemFn} />
          )}
        </div>
      )}

      { dataset.length === 0 && (
        <div className="w-full h-10 text-sm text-slate-500">
          <span>No records found.</span>
          { addItemFn !== undefined && (
            <span className="pl-1">Click the plus button above to add a new item.</span>
          )}
        </div>
      )}

      { dataset.length > 0 && (
        <>
          <div className="w-full mt-4 px-1 grid grid-cols-24">
            <div className="w-full col-span-24 grid grid-cols-24 pb-2 border-b border-solid border-slate-700">
              { columns.map( (col:any, idx:number) => (
                <GridTableHeader key={idx} {...col} />
              ))}
            </div>
            { dataset.map( (item:any, idx:number) => (
              <GridTableRow 
                key={idx}
                item={item}
                isSelectedFn={isSelectedFn}
                columns={columns}
                rowClickFn={rowClickFn}
                actions={actions}
              />
            ))}
          </div>

          { pagination && pagination.total > dataset.length && (
            <div className="w-full mt-4 flex justify-end items-center">
              <Pagination 
                totalRecords={pagination.total} 
                currentPage={pagination._page} 
                recordsPerPage={pagination._perpage}
                className="w-full mt-4"
              />
            </div>
          )}
        </>
      )}
    </div> 
  )
}